import { MapRepository } from '../../infrastructure/repositories/MapRepository';
import { Position, Marker } from '../../domain/entities/map.types';

export class HandleMapInteractions {
  readonly mapRepository: MapRepository;
  private onMarkerSelected?: (marker: Marker) => void;

  constructor(mapRepository: MapRepository) {
    this.mapRepository = mapRepository;
  }

  setOnMarkerSelected(callback: (marker: Marker) => void): void {
    this.onMarkerSelected = callback;
  }

  async handleMarkerClick(markerId: string): Promise<void> {
    const allMarkers = await this.mapRepository.getMarkers();
    const marker = allMarkers.find((m) => String(m.id) === String(markerId));

    if (marker) {
      // Call the marker's onClick if it exists
      if (marker.onClick) {
        marker.onClick({} as google.maps.MapMouseEvent);
      }

      // Notify about marker selection for details panel
      if (this.onMarkerSelected) {
        this.onMarkerSelected(marker);
      }
    }
  }

  async handleMarkerDrag(markerId: string, newPosition: Position): Promise<void> {
    await this.mapRepository.updateMarkerPosition(markerId, newPosition);
  }
}
